var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import classNames from "classnames";
import { stickyScrollParentCls, stickyScrollParentFixedCls, stickyScrollParentBottomFixedCls, stickyScrollParentInnerCls } from "./Parent.less";
function isElementInViewport(el, innerEl) {
  var rect = el.getBoundingClientRect();
  var innerRect = innerEl.getBoundingClientRect();
  return {
    top: rect.top <= 0,
    bottom: rect.bottom - innerRect.height <= 0,
    width: rect.width,
    isParentHigherThanChild: rect.height > innerRect.height
  };
}
__name(isElementInViewport, "isElementInViewport");
var StickyScrollParent = /* @__PURE__ */ function(_Component) {
  function StickyScrollParent2(props) {
    var _this;
    _classCallCheck(this, StickyScrollParent2);
    _this = _callSuper(this, StickyScrollParent2, [props]);
    _defineProperty(_this, "elementPositions", {
      isFixed: false,
      isBottomFixed: false
    });
    _defineProperty(_this, "innerRefHandler", function(innerRef) {
      _this.innerRef = innerRef;
    });
    _defineProperty(_this, "wrapperRefHandler", function(wrapperRef) {
      _this.wrapperRef = wrapperRef;
    });
    _this.bindMethods();
    _this.state = {
      isFixed: false,
      isBottomFixed: false,
      parentWidth: 0
    };
    return _this;
  }
  __name(StickyScrollParent2, "StickyScrollParent");
  _inherits(StickyScrollParent2, _Component);
  return _createClass(StickyScrollParent2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      this.handleScroll();
      window.addEventListener("scroll", this.handleScroll);
    }, "componentDidMount")
    /**
     * componentWillUnmount
     */
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    }, "componentWillUnmount")
  }, {
    key: "handleScroll",
    value: (
      /**
       * handleScroll
       */
      /* @__PURE__ */ __name(function handleScroll() {
        var elementPosition = isElementInViewport(this.wrapperRef, this.innerRef);
        if (!elementPosition.isParentHigherThanChild) {
          return;
        }
        var currentPositions = {
          isFixed: elementPosition.top && !elementPosition.bottom,
          isBottomFixed: elementPosition.bottom
        };
        if (this.elementPositions.isFixed !== currentPositions.isFixed || this.elementPositions.isBottomFixed !== currentPositions.isBottomFixed) {
          this.setState(_objectSpread(_objectSpread({}, currentPositions), {}, {
            parentWidth: elementPosition.width
          }));
        }
        this.elementPositions = _objectSpread({}, currentPositions);
      }, "handleScroll")
    )
  }, {
    key: "bindMethods",
    value: (
      /**
       * bindMethods
       */
      /* @__PURE__ */ __name(function bindMethods() {
        this.handleScroll = this.handleScroll.bind(this);
      }, "bindMethods")
    )
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$state = this.state, isFixed = _this$state.isFixed, isBottomFixed = _this$state.isBottomFixed, parentWidth = _this$state.parentWidth;
      return /* @__PURE__ */ React.createElement("div", {
        ref: this.wrapperRefHandler,
        className: classNames(stickyScrollParentCls, _defineProperty(_defineProperty({}, stickyScrollParentFixedCls, isFixed), stickyScrollParentBottomFixedCls, isBottomFixed))
      }, /* @__PURE__ */ React.createElement("div", {
        ref: this.innerRefHandler,
        className: stickyScrollParentInnerCls,
        style: isFixed && parentWidth ? {
          width: "".concat(parentWidth, "px")
        } : {}
      }, this.props.children));
    }, "render")
  }]);
}(Component);
export {
  StickyScrollParent
};
